// extracted by mini-css-extract-plugin
export default {"strip":"iEBFKI","content":"lXJisU","divider":"fxNF5c","iconTile":"vc_mTF","title":"TSku7S","description":"YHlCXv"};